import React from "react";
import Field from "./Field";
import TextboxControl from "./TextboxControl";
import { FieldProps } from "./Types";

const TextboxField: React.FC<FieldProps> = ({ labelProps, controlProps, additionalElement, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <TextboxControl {...controlProps} disabled={disabled} />
            {additionalElement}
        </Field>
    );
}
export default TextboxField;